import { Reimbursement } from "#/types/reimbursement"
import { ExpenseState } from "../../../../utils/ExpenseState"
import { ExpenseType } from "../../../../utils/ExpenseType"
import { BenefitType, Subsidy } from "#/lib/carrot-api/types/Subsidy"

// Credit members' dollar line: hidden when the paired fund is non-reimbursable or has none left.
export const shouldShowPairedFunds = (subsidy: Subsidy): boolean =>
  subsidy.benefitType !== BenefitType.CREDIT &&
  subsidy.isReimbursable !== false &&
  (subsidy.hasUnlimitedBenefit ||
    [subsidy.yearlyAmounts.available, subsidy.lifetimeAmounts.available].every(
      (amount) => amount == null || amount > 0
    ))

export const getReimbursementsRequiringActionList = (reimbursements: Reimbursement[]) => {
  const reimbursementsRequiringAction = reimbursements.filter(
    (x: Reimbursement) =>
      (x.reconciliationRequestedExpenseId && x.adjustmentDatetime === null) ||
      x.expenseState === ExpenseState.NEEDS_MEMBER_UPLOADS ||
      (x.expenseType === ExpenseType.CARD &&
        (x.expenseState === ExpenseState.DENIED_RECONCILIATION_REQUESTED ||
          x.expenseState === ExpenseState.PENDING_MEMBER_INFO))
  )

  const { reconciliationExpenses, otherExpenses } = reimbursementsRequiringAction.reduce(
    (acc, reimbursement) => {
      const isReconciliationExpense =
        !!reimbursement.reconciliationRequestedExpenseId ||
        reimbursement.expenseState === ExpenseState.DENIED_RECONCILIATION_REQUESTED

      if (isReconciliationExpense) {
        acc.reconciliationExpenses.push(reimbursement)
      } else {
        acc.otherExpenses.push(reimbursement)
      }

      return acc
    },
    { reconciliationExpenses: [], otherExpenses: [] } as {
      reconciliationExpenses: Reimbursement[]
      otherExpenses: Reimbursement[]
    }
  )

  const sortedReconciliationExpenses = reconciliationExpenses.sort(
    (a, b) => new Date(b.submittedDatetime).getTime() - new Date(a.submittedDatetime).getTime()
  )

  return [...sortedReconciliationExpenses, ...otherExpenses]
}

// @ts-expect-error TS(7006) FIXME: Parameter 'reimbursements' implicitly has an 'any'... Remove this comment to see the full error message
export const getPendingReimbursementsList = (reimbursements) => {
  return reimbursements
    ? reimbursements.filter(
        // @ts-expect-error TS(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
        (x) =>
          (x.expenseType !== ExpenseType.CARD &&
            (x.expenseState === ExpenseState.RECEIVED ||
              x.expenseState === ExpenseState.PENDING_PRIMARY_SERVICE ||
              x.expenseState === ExpenseState.APPROVED ||
              x.expenseState === ExpenseState.INVOICING ||
              x.expenseState === ExpenseState.INVOICED)) ||
          (x.expenseType === ExpenseType.CARD && x.expenseState === ExpenseState.PENDING_CARE_NAV) ||
          x.expenseState === ExpenseState.ON_HOLD ||
          x.expenseState === ExpenseState.SCHEDULED ||
          x.expenseState === ExpenseState.NEEDS_PROVIDER_INFO ||
          x.expenseState === ExpenseState.BILL_SUBMITTED ||
          x.expenseState === ExpenseState.PENDING_NEXT_PLAN_YEAR
      )
    : []
}

// @ts-expect-error TS(7006) FIXME: Parameter 'reimbursements' implicitly has an 'any'... Remove this comment to see the full error message
export const getCategoryPendingReimbursementsList = (reimbursements) => {
  return reimbursements
    ? reimbursements.filter(
        // @ts-expect-error TS(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
        (x) =>
          (x.expenseType !== ExpenseType.CARD &&
            ((x.expenseState === ExpenseState.RECEIVED && x.hasLineItems) ||
              x.expenseState === ExpenseState.PENDING_PRIMARY_SERVICE ||
              x.expenseState === ExpenseState.APPROVED ||
              x.expenseState === ExpenseState.INVOICING ||
              x.expenseState === ExpenseState.INVOICED)) ||
          (x.expenseType === ExpenseType.CARD && x.expenseState === ExpenseState.PENDING_CARE_NAV) ||
          x.expenseState === ExpenseState.ON_HOLD ||
          x.expenseState === ExpenseState.SCHEDULED ||
          x.expenseState === ExpenseState.NEEDS_PROVIDER_INFO ||
          x.expenseState === ExpenseState.BILL_SUBMITTED ||
          x.expenseState === ExpenseState.PENDING_NEXT_PLAN_YEAR
      )
    : []
}

// @ts-expect-error TS(7006) FIXME: Parameter 'reimbursements' implicitly has an 'any'... Remove this comment to see the full error message
export const getReceivedReimbursementsList = (reimbursements) => {
  return reimbursements
    ? reimbursements.filter(
        (x: any) => x.expenseType !== ExpenseType.CARD && x.expenseState === ExpenseState.RECEIVED && !x.hasLineItems
      )
    : []
}

// @ts-expect-error TS(7006) FIXME: Parameter 'reimbursements' implicitly has an 'any'... Remove this comment to see the full error message
export const getCompletedReimbursementsList = (reimbursements) => {
  return reimbursements
    ? reimbursements.filter(
        // @ts-expect-error TS(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
        (x) =>
          (x.expenseType !== ExpenseType.CARD &&
            (x.expenseState === ExpenseState.DENIED ||
              (x.expenseState === ExpenseState.PAID && !x.reconciliationRequestedExpenseId))) ||
          (x.expenseType === ExpenseType.CARD &&
            (x.expenseState === ExpenseState.APPROVED || x.expenseState === ExpenseState.DENIED_RECONCILED)) ||
          x.expenseState === ExpenseState.CANCELLED
      )
    : []
}

// @ts-expect-error TS(7006) FIXME: Parameter 'reimbursements' implicitly has an 'any'... Remove this comment to see the full error message
export const getCategoryPendingOrCompletedReimbursementsList = (reimbursements) => {
  return getCategoryPendingReimbursementsList(reimbursements) + getCompletedReimbursementsList(reimbursements)
}
